import {
  dietOptions,
  entrealDietOptions,
  liquidDietOptions,
  oralDietOptions,
  rootFeedOptions,
  parentalTypeOptions,
} from "../../Options/dietAdviceOptions";
import DeselectableRadioGroup from "../../../../blocks/FormItems/DeselectableRadioGroup";
import { Form, Input, InputNumber } from "antd";

const TypeOfDiet = ({ form }) => {
  const entrealFeedingType = Form.useWatch(
    ["diet_details", "type_of_feedings"],
    form
  );
  const dietType = Form.useWatch(["diet_details", "diet"], form);
  const typeOfOralDiet = Form.useWatch(
    ["diet_details", "type_of_oral_diet"],
    form
  );
  const typeOfParenteralDiet = Form.useWatch(
    ["diet_details", "type_of_parenteral_diet"],
    form
  );

  return (
    <>
      <DeselectableRadioGroup
        label={"Type of Diet"}
        name={["diet_details", "diet"]}
        options={dietOptions}
        form={form}
      />
      {dietType === "oral" && (
        <div className="subsection-card">
          <DeselectableRadioGroup
            label={"Type of Oral Diet"}
            name={["diet_details", "type_of_oral_diet"]}
            options={oralDietOptions}
            form={form}
          />
          {typeOfOralDiet === "liquid" && (
            <DeselectableRadioGroup
              label={"Type of Liquid Diet"}
              name={["diet_details", "type_of_liquid_diet"]}
              options={liquidDietOptions}
              form={form}
            />
          )}
        </div>
      )}

      {dietType === "enteral" && (
        <div className="subsection-card">
          <DeselectableRadioGroup
            label={"Type of Feedings"}
            name={["diet_details", "type_of_feedings"]}
            options={entrealDietOptions}
            form={form}
          />

          {entrealFeedingType && (
            <DeselectableRadioGroup
              label={"Root of Enteral Feed"}
              name={["diet_details", "root_of_enteral_feed"]}
              options={rootFeedOptions}
              form={form}
            />
          )}
        </div>
      )}
      {dietType === "parenteral" && (
        <div className="subsection-card">
          <DeselectableRadioGroup
            label={"Type of Parenteral Diet"}
            name={["diet_details", "type_of_parenteral_diet"]}
            options={parentalTypeOptions}
            form={form}
          />
          {typeOfParenteralDiet && (
            <>
              {typeOfParenteralDiet === "total_parental_nutrition" && (
                <Form.Item
                  label="Central Line"
                  name={["diet_details", "parental_central_line"]}
                >
                  <Input
                    style={{ maxWidth: 800 }}
                    placeholder="Infusion Rate"
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Peripheral Line"
                name={["diet_details", "parental_peripheral_line"]}
              >
                <Input style={{ maxWidth: 800 }} placeholder="Infusion Rate" />
              </Form.Item>
            </>
          )}
        </div>
      )}
      {/* {["enteral", "parenteral"]?.includes(dietType) && (
        <>
          <Form.Item
            label="Carbohydrates"
            name={["nutritional_recommendations", "carbohydrates"]}
          >
            <InputNumber addonAfter="gms/day" />
          </Form.Item>
          <Form.Item
            label="Sodium"
            name={["nutritional_recommendations", "sodium"]}
          >
            <InputNumber addonAfter="mg/day" />
          </Form.Item>
          <Form.Item
            label="Potassium"
            name={["nutritional_recommendations", "potassium"]}
          >
            <InputNumber addonAfter="mg/day" />
          </Form.Item>
        </>
      )} */}
    </>
  );
};

export default TypeOfDiet;
